import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const TaskScheduledFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 2.68C12.84 2.68 13.76 3.28 13.82 4.66H10.18C10.24 3.28 11.16 2.68 12 2.68ZM5.42 19.84V4.08H9.06V5.72H14.94V4.08H18.58V19.84H5.42ZM9.62 10.2C10.12 10.2 10.54 9.78 10.54 9.28C10.54 8.78 10.12 8.36 9.62 8.36C9.12 8.36 8.7 8.78 8.7 9.28C8.7 9.78 9.12 10.2 9.62 10.2ZM11.34 8.56V10H14.88V8.56H11.34ZM9.62 13.32C10.12 13.32 10.54 12.9 10.54 12.4C10.54 11.9 10.12 11.48 9.62 11.48C9.12 11.48 8.7 11.9 8.7 12.4C8.7 12.9 9.12 13.32 9.62 13.32ZM11.34 11.68V13.12H14.88V11.68H11.34ZM9.62 16.44C10.12 16.44 10.54 16.02 10.54 15.52C10.54 15.02 10.12 14.6 9.62 14.6C9.12 14.6 8.7 15.02 8.7 15.52C8.7 16.02 9.12 16.44 9.62 16.44ZM11.34 14.8V16.24H14.88V14.8H11.34Z" />
    </SvgIcon>
  );
});
